/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetSmsBalanceParams,
  SmsBalanceResponse,
  SmsMultiMessageRequest,
  SmsMultiMessageResponse,
  SmsRequest,
  SmsResponse
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const sendSingleSms = (
    smsRequest: SmsRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SmsResponse>(
      {url: `/api/v1/customer/sms/single`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: smsRequest, signal
    },
      options);
    }
  


export const getSendSingleSmsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendSingleSms>>, TError,{data: SmsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sendSingleSms>>, TError,{data: SmsRequest}, TContext> => {

const mutationKey = ['sendSingleSms'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendSingleSms>>, {data: SmsRequest}> = (props) => {
          const {data} = props ?? {};

          return  sendSingleSms(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendSingleSmsMutationResult = NonNullable<Awaited<ReturnType<typeof sendSingleSms>>>
    export type SendSingleSmsMutationBody = SmsRequest
    export type SendSingleSmsMutationError = unknown

    export const useSendSingleSms = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendSingleSms>>, TError,{data: SmsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendSingleSms>>,
        TError,
        {data: SmsRequest},
        TContext
      > => {

      const mutationOptions = getSendSingleSmsMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const sendMultipleMessages = (
    smsMultiMessageRequest: SmsMultiMessageRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SmsMultiMessageResponse>(
      {url: `/api/v1/customer/sms/multi`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: smsMultiMessageRequest, signal
    },
      options);
    }
  


export const getSendMultipleMessagesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendMultipleMessages>>, TError,{data: SmsMultiMessageRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sendMultipleMessages>>, TError,{data: SmsMultiMessageRequest}, TContext> => {

const mutationKey = ['sendMultipleMessages'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendMultipleMessages>>, {data: SmsMultiMessageRequest}> = (props) => {
          const {data} = props ?? {};

          return  sendMultipleMessages(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendMultipleMessagesMutationResult = NonNullable<Awaited<ReturnType<typeof sendMultipleMessages>>>
    export type SendMultipleMessagesMutationBody = SmsMultiMessageRequest
    export type SendMultipleMessagesMutationError = unknown

    export const useSendMultipleMessages = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendMultipleMessages>>, TError,{data: SmsMultiMessageRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendMultipleMessages>>,
        TError,
        {data: SmsMultiMessageRequest},
        TContext
      > => {

      const mutationOptions = getSendMultipleMessagesMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const getSmsBalance = (
    params?: GetSmsBalanceParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SmsBalanceResponse>(
      {url: `/api/v1/customer/sms/balance`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetSmsBalanceQueryKey = (params?: GetSmsBalanceParams,) => {
    return [`/api/v1/customer/sms/balance`, ...(params ? [params]: [])] as const;
    }

    
export const getGetSmsBalanceQueryOptions = <TData = Awaited<ReturnType<typeof getSmsBalance>>, TError = unknown>(params?: GetSmsBalanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSmsBalance>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSmsBalanceQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSmsBalance>>> = ({ signal }) => getSmsBalance(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSmsBalance>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetSmsBalanceQueryResult = NonNullable<Awaited<ReturnType<typeof getSmsBalance>>>
export type GetSmsBalanceQueryError = unknown


export function useGetSmsBalance<TData = Awaited<ReturnType<typeof getSmsBalance>>, TError = unknown>(
 params: undefined |  GetSmsBalanceParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSmsBalance>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSmsBalance>>,
          TError,
          Awaited<ReturnType<typeof getSmsBalance>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSmsBalance<TData = Awaited<ReturnType<typeof getSmsBalance>>, TError = unknown>(
 params?: GetSmsBalanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSmsBalance>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSmsBalance>>,
          TError,
          Awaited<ReturnType<typeof getSmsBalance>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSmsBalance<TData = Awaited<ReturnType<typeof getSmsBalance>>, TError = unknown>(
 params?: GetSmsBalanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSmsBalance>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetSmsBalance<TData = Awaited<ReturnType<typeof getSmsBalance>>, TError = unknown>(
 params?: GetSmsBalanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSmsBalance>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetSmsBalanceQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



